<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {NuxtPage} from '#components';
    import {use3rdParties, useHTMLAttrsLang} from '#imports';

    use3rdParties();
    useHTMLAttrsLang();
</script>
